'use client';

import { useParams } from 'next/navigation';

import { TinyURLWrapper } from './_components/TinyURLWrapper';

export default function TinyURLPage() {
  const params = useParams();
  const tinyURL = params?.tinyURL;

  if (!tinyURL || typeof tinyURL !== 'string') return <div>Invalid URL</div>;

  return (
    <div className="size-full min-h-dvh flex justify-center items-center">
      <TinyURLWrapper tinyURL={tinyURL} />
    </div>
  );
}
